export const REGISTRATION_STATUS_OPTIONS = [
  { value: 0, label: 'Approved' },
  { value: 1, label: 'Pending' },
  { value: 2, label: 'Rejected' },
  { value: 3, label: 'Unregistered' },
  { value: 4, label: 'Suspended' },
  { value: 5, label: 'Resigned' },
] as const

export const getRegistrationStatusLabel = (value: number | null | undefined) => {
  switch (value) {
    case 0:
      return 'Approved'
    case 1:
      return 'Pending'
    case 2:
      return 'Rejected'
    case 3:
      return 'Unregistered'
    case 4:
      return 'Suspended'
    case 5:
      return 'Resigned'
    default:
      return 'Unknown'
  }
}

export const getRegistrationStatusBadgeClass = (value: number | null | undefined) => {
  switch (value) {
    case 0:
      return 'border-emerald-200 bg-emerald-50 text-emerald-700'
    case 1:
      return 'border-amber-200 bg-amber-50 text-amber-700'
    case 2:
      return 'border-rose-200 bg-rose-50 text-rose-700'
    case 3:
      return 'border-slate-200 bg-slate-50 text-slate-700'
    case 4:
      return 'border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700'
    case 5:
      return 'border-zinc-300 bg-zinc-100 text-zinc-700'
    default:
      return 'border-border bg-muted text-foreground'
  }
}